/* NoraVesa — core theme behavior (vanilla JS, no build step required) */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  function initScrollProgress() {
    var bar = document.querySelector("[data-scroll-progress]");
    var header = document.querySelector("[data-site-header]");
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var scrollable = h.scrollHeight - h.clientHeight;
      var pct = scrollable > 0 ? (h.scrollTop / scrollable) * 100 : 0;
      if (bar) bar.style.width = pct + "%";
      if (header) header.classList.toggle("is-scrolled", h.scrollTop > 4);
      ticking = false;
    }
    document.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  function initFadeAnimations() {
    var targets = document.querySelectorAll("[data-animate]");
    if (!targets.length) return;
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px -10% 0px" });
    targets.forEach(function (el) { observer.observe(el); });
  }

  function openDrawer(name) {
    var el = document.querySelector('[data-drawer="' + name + '"]');
    if (!el) return;
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open-lock");
    var focusable = el.querySelector("button, a, input, select, textarea");
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeDrawer(name) {
    var el = name
      ? document.querySelector('[data-drawer="' + name + '"]')
      : document.querySelector(".drawer.is-open, .modal.is-open");
    if (!el) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    if (!document.querySelector(".drawer.is-open")) {
      document.body.classList.remove("drawer-open-lock");
    }
  }
  function initDrawers() {
    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-drawer-open]");
      if (openBtn) {
        e.preventDefault();
        openDrawer(openBtn.getAttribute("data-drawer-open"));
        return;
      }
      var closeBtn = e.target.closest("[data-drawer-close]");
      if (closeBtn) {
        e.preventDefault();
        var parentDrawer = closeBtn.closest("[data-drawer]");
        closeDrawer(parentDrawer ? parentDrawer.getAttribute("data-drawer") : null);
        return;
      }
      var overlay = e.target.closest(".drawer__overlay");
      if (overlay) {
        var parent = overlay.closest("[data-drawer]");
        closeDrawer(parent ? parent.getAttribute("data-drawer") : null);
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }
  window.NoraVesa = window.NoraVesa || {};
  window.NoraVesa.openDrawer = openDrawer;
  window.NoraVesa.closeDrawer = closeDrawer;

  var WISHLIST_KEY = "noravesa:wishlist";
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(handles) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
    updateWishlistCount();
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll("[data-wishlist-count-value]").forEach(function (el) {
      el.textContent = count;
    });
  }
  function syncWishlistButtons() {
    var handles = getWishlist();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-product-handle");
      btn.classList.toggle("is-active", handles.indexOf(handle) !== -1);
    });
  }
  function initWishlist() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-wishlist-toggle]");
      if (!btn) return;
      var handle = btn.getAttribute("data-product-handle");
      var handles = getWishlist();
      var idx = handles.indexOf(handle);
      if (idx === -1) handles.push(handle); else handles.splice(idx, 1);
      setWishlist(handles);
      btn.classList.toggle("is-active", idx === -1);
    });
    syncWishlistButtons();
    updateWishlistCount();
  }
  window.NoraVesa.getWishlist = getWishlist;

  function refreshCartDrawer() {
    return fetch("/?sections=cart-drawer")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var wrapper = document.createElement("div");
        wrapper.innerHTML = html;
        var newDrawer = wrapper.querySelector("[data-drawer='cart']");
        var oldDrawer = document.querySelector("[data-drawer='cart']");
        if (newDrawer && oldDrawer) {
          oldDrawer.replaceWith(newDrawer);
          if (oldDrawer.classList.contains("is-open")) newDrawer.classList.add("is-open");
        }
      })
      .catch(function () {});
  }
  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
    });
  }
  function initAddToCartForms() {
    document.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-product-card-add-form], [data-product-form]");
      if (!form) return;
      e.preventDefault();
      var button = form.querySelector("button[type='submit']");
      var originalText = button ? button.textContent : "";
      if (button) { button.disabled = true; button.textContent = "Ekleniyor…"; }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: new FormData(form).get("id"), quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshCartDrawer();
        })
        .then(function () {
          openDrawer("cart");
        })
        .catch(function () {
          window.location.href = "/cart";
        })
        .finally(function () {
          if (button) { button.disabled = false; button.textContent = originalText; }
        });
    });
  }

  function initSwatches() {
    document.addEventListener("click", function (e) {
      var swatch = e.target.closest("[data-swatch]");
      if (!swatch) return;
      e.preventDefault();
      var card = swatch.closest("[data-product-card]");
      if (!card) return;
      var newSrc = swatch.getAttribute("data-image");
      if (!newSrc) return;

      var mainImg = card.querySelector("[data-main-image]");
      if (mainImg) {
        mainImg.removeAttribute("srcset");
        mainImg.removeAttribute("sizes");
        mainImg.src = newSrc;
      }

      var hoverImg = card.querySelector(".product-card__img--hover");
      if (hoverImg) {
        hoverImg.removeAttribute("srcset");
        hoverImg.src = newSrc;
      }

      card.querySelectorAll("[data-swatch]").forEach(function (s) { s.classList.remove("is-active"); });
      swatch.classList.add("is-active");
    });
  }

  function initCartQuantity() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cart-qty-change]");
      if (!btn) return;
      var key = btn.getAttribute("data-line-key");
      var delta = parseInt(btn.getAttribute("data-cart-qty-change"), 10);
      var input = document.querySelector('[data-cart-qty-input="' + key + '"]');
      if (!input) return;
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      updateCartLine(key, newQty);
    });
    document.addEventListener("click", function (e) {
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (!removeBtn) return;
      e.preventDefault();
      updateCartLine(removeBtn.getAttribute("data-cart-remove"), 0);
    });
  }
  function updateCartLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer();
      })
      .then(function () {
        if (window.location.pathname.indexOf("/cart") === 0) window.location.reload();
      })
      .catch(function () {});
  }

  function initInfiniteScroll() {
    var grid = document.querySelector("[data-infinite-scroll]");
    if (!grid) return;

    var container = grid.parentElement;
    var loader = container ? container.querySelector("[data-infinite-loader]") : null;
    var fallbackNav = container ? container.querySelector("[data-pagination-fallback]") : null;
    var nextUrl = grid.getAttribute("data-next-url");
    if (!nextUrl) return;

    if (fallbackNav) fallbackNav.style.display = "none";

    var sentinel = document.createElement("div");
    sentinel.setAttribute("data-infinite-sentinel", "");
    sentinel.style.cssText = "height:1px;";
    grid.insertAdjacentElement("afterend", sentinel);

    var loading = false;

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      if (loader) loader.hidden = false;

      fetch(nextUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newGrid = doc.querySelector("[data-infinite-scroll]");
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (card) {
              grid.appendChild(card);
            });
            nextUrl = newGrid.getAttribute("data-next-url") || "";
          } else {
            nextUrl = "";
          }
          if (!nextUrl) {
            observer.disconnect();
            sentinel.remove();
          }
        })
        .catch(function () {
          nextUrl = "";
          observer.disconnect();
        })
        .finally(function () {
          loading = false;
          if (loader) loader.hidden = true;
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNext();
      });
    }, { rootMargin: "600px 0px" });
    observer.observe(sentinel);
  }

  function tagHeader() {
    var header = document.querySelector(".site-header");
    if (header) header.setAttribute("data-site-header", "");
  }

  document.addEventListener("DOMContentLoaded", function () {
    tagHeader();
    initScrollProgress();
    initFadeAnimations();
    initDrawers();
    initWishlist();
    initAddToCartForms();
    initSwatches();
    initCartQuantity();
    initInfiniteScroll();
  });
})();
